import * as Icons from "@mui/icons-material";

export default function Icon({ name, ...props }) {
  // 1. Defina o componente baseado no nome recebido
  const IconComponent = Icons[name];

  // 2. (Segurança) Se o nome não existir ou estiver errado, não renderiza nada para evitar crash
  if (!IconComponent) {
    return null; 
  }

  // 3. Agora a variável IconComponent existe e pode ser usada como tag
  return (
    <IconComponent 
      sx={{ color: "primary.main" }} 
      fontSize="large" 
      {...props} 
    />
  );
}